export const environment = {
  production: false,
  API_URL: 'https://api.dev.qeleo.ai/v1',
};
